module.exports = __webpack_public_path__ + "media/Video 108.7511a966.mp4";